module.exports = __webpack_public_path__ + "img/ZG81_09.dc10ff4f.jpg";